import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { CreateNotificationDto, FindNotificationsDto, GetNotificationTargetAccountNameResponse, NotificationsResponse } from '@/@types/Notification';

export class NotificationsRepository {
  private readonly requestBasePath = 'v1/notifications';
  private readonly axios = new TheoryApiAxiosBase();

  async fetchNotification(params: FindNotificationsDto) {
    const path = `${this.requestBasePath}/all`;
      const response = await this.axios.post<NotificationsResponse>(path, params);
      return response.data;
  }

  async getNotificationTargetAccountName(accountId: number) {
    const path = `${this.requestBasePath}/${accountId}/target-name`;
    return (await this.axios.get<GetNotificationTargetAccountNameResponse>(path)).data;
  }

  async createNotification(params: CreateNotificationDto) {
    await this.axios.post(this.requestBasePath, params);
  }
}
